<template>
  <transition name="toast">
    <div v-if="toast.visible" class="greet-toast" role="status">
      <div class="greet-head">
        <depa-bird :size="16" class="mr-2"></depa-bird>
        <span class="greet-title">{{ toast.title }}</span>
        <span class="greet-time">เมื่อสักครู่</span>
        <button type="button" class="greet-close" aria-label="ปิด" @click="close">
          <v-icon small color="white">mdi-close</v-icon>
        </button>
      </div>
      <div class="greet-body">{{ toast.message }}</div>
    </div>
  </transition>
</template>

<script>
import DepaBird from './DepaBird.vue';
import { greetingToast, hideGreeting } from '@/fun/greetingToast';

// แสดง 5 วินาทีแล้วหายเอง
const SHOW_MS = 5000;

export default {
  name: 'GreetingToast',
  components: { DepaBird },
  data() {
    return { toast: greetingToast, timer: null };
  },
  watch: {
    'toast.visible'(visible) {
      clearTimeout(this.timer);
      if (visible) this.timer = setTimeout(hideGreeting, SHOW_MS);
    },
  },
  beforeDestroy() {
    clearTimeout(this.timer);
  },
  methods: {
    close() {
      hideGreeting();
    },
  },
};
</script>

<style scoped>
.greet-toast {
  position: fixed;
  top: 76px;
  right: 20px;
  z-index: 300;
  width: 340px;
  max-width: calc(100vw - 32px);
  border-radius: 12px;
  overflow: hidden;
  background: #FFFFFF;
  box-shadow: 0 10px 30px rgba(12, 47, 83, 0.25);
}

.greet-head {
  display: flex;
  align-items: center;
  padding: 10px 12px 10px 14px;
  background: #0C2F53;
  color: #FFFFFF;
}

.greet-title {
  flex: 1;
  font-weight: 700;
  font-size: 15px;
}

.greet-time {
  margin-right: 8px;
  font-size: 12px;
  color: rgba(255, 255, 255, 0.7);
}

.greet-close {
  display: flex;
  padding: 2px;
  border-radius: 50%;
}

.greet-close:hover {
  background: rgba(255, 255, 255, 0.15);
}

.greet-body {
  padding: 14px 16px 16px;
  color: #2B3A4D;
  font-size: 15px;
  line-height: 1.5;
  border-left: 4px solid #FFC600;
}

.toast-enter-active,
.toast-leave-active {
  transition: transform 0.35s ease, opacity 0.35s ease;
}

.toast-enter,
.toast-leave-to {
  opacity: 0;
  transform: translateX(40px);
}

html.no-motion .toast-enter-active,
html.no-motion .toast-leave-active {
  transition: none;
}
</style>
